import { render, staticRenderFns } from "./serviceProcess.vue?vue&type=template&id=470a80d3&scoped=true&"
import script from "./serviceProcess.vue?vue&type=script&lang=js&"
export * from "./serviceProcess.vue?vue&type=script&lang=js&"
import style0 from "./serviceProcess.vue?vue&type=style&index=0&id=470a80d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a80d3",
  null
  
)

export default component.exports